module.exports = __webpack_public_path__ + "static/media/jupiter.7d2c9d6a.svg";